import { useQuery } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import Navbar from '../../../components/Navbar';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { MaterialReactTable } from 'material-react-table';

import Loaders from '../../../components/Loaders';
import { Link } from 'react-router-dom';
import { Switch } from '@mui/material';

export default function Countries() {
    const axiosPrivate = useAxiosPrivate();


    const handleCountries = () => {
        const res = axiosPrivate.get(`country/all`)
        return res;
    };
    const handleCountryStatus = async (code, value) => {
        const response = await axiosPrivate.put(`country/status/${code}`, {
            status: value
        });
        refetch()
        return response;
    }


    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => <img src={row.flag} alt="Flag" height='50px' />,
                header: "Image",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.name,
                header: "Name",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.code,
                header: "Code",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.currency_code,
                header: "Currency Code",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.phone_prefix,
                header: "Phone prefix",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => <Switch defaultChecked={row.is_active} onChange={(e) => handleCountryStatus(row.code, e.target.checked)} />,
                header: "Status",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => (
                    <>
                        <Link to={`/admin/dashboard/countries/edit/${row.code}`} className='btn btn-success '><i className="fa-regular fa-pen-to-square"></i></Link>
                    </>
                ),
                id: "action", //id required if you use accessorFn instead of accessorKey
                header: "Action",
                Header: <i style={{ color: "red" }}>Action</i> //
            }
        ],
        [],
    );

    const { data: allCountries = [], isLoading, refetch } = useQuery({
        queryKey: ['get-Countries'],
        queryFn: handleCountries,
        cacheTime: 5000,
    })
    return (
        <>
            <Navbar
                title="Countries"
                btnTitle="Add New Country"
                btnLink="/admin/dashboard/countries/create"
            />
            {
                isLoading && <div className="d-flex justify-content-center align-items-center">
                    <Loaders />
                </div>
            }



            <div className='container my-5'>


                {allCountries?.data?.data &&
                    <>
                        <MaterialReactTable
                            columns={columns}
                            data={allCountries?.data?.data}
                        />
                    </>
                }
            </div>
        </>
    )
}
